import stringFormatService from '../../services/stringFormatService';
import {config} from '../config';
import {TConfigGetterReturn} from './types';

const getBaseName = (): TConfigGetterReturn<number> => config.data.app.baseName;

export default {
    getAppVersion: (): TConfigGetterReturn<string> => config.data.app.appVersion,
    getIsBLEEnabled: (): TConfigGetterReturn<string> => config.data.app.isBLEEnabled,
    getBackendType: (): TConfigGetterReturn<number> => config.data.app.backendType,
    getBaseNameFormatted: (): TConfigGetterReturn<string> =>
        stringFormatService.getLanguageFormattedString(getBaseName()),
    getDefaultVeevImage: (): TConfigGetterReturn<string> => config.data.app.defaultVeevImage,
    getDeviceListOrder: (): TConfigGetterReturn<string[]> => config.data.app.deviceListOrder,
    getEnv: (): TConfigGetterReturn<string> => config.data.app.env,
    getIsReconnectDeviceGuideEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isReconnectDeviceGuideEnabled,
    getPublicUrl: (): TConfigGetterReturn<string> => config.data.app.publicUrl,
    getIsDataCollectionEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isDataCollectionEnabled,
    getIsCaptchaEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isCaptchaEnabled,
    getIsSuccessfullyUpdatedPageIconEnabled: (): TConfigGetterReturn<boolean> =>
        config.data.app.isSuccessfullyUpdatedPageIconEnabled,
};
